<template>
  <div>
    <div class="login">
      <div class="main">
        <img src='../assets/images/common/loading.gif' alt="" width="150" class="animate__animated animate__bounceOut">
        <div class="text animate__animated animate__bounceOut" style="margin-bottom: 30px">Loading...</div>
        <p style="margin-top: 20px">{{ msg }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {loginOut} from '@/api/login'

export default {
  components: {},
  data() {
    return {
      msg: "",
    }
  },
  mounted() {
    let userInfo = {
      yhid: Number(this.$route.query.yhid),
      zhid: Number(this.$route.query.zhid),
      realname: this.$route.query.realname,
      jsmc: this.$route.query.jsmc,
      xb: Number(this.$route.query.xb),
      zhmc: this.$route.query.zhmc,
      yhm: this.$route.query.yhm,
    }
    // 地址栏没有携带参数，点击退出登录进的login页
    if (!userInfo.zhid || !userInfo.yhid) {
      loginOut({yhid: this.$store.state.speedReading.userInfo.yhid + ''}).then(res => {
        if (res.success) {
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('userInfo')

        } else {
          this.msg = res.resultDesc
        }
      })
    } else {
      sessionStorage.setItem('yycdid', this.$route.query.yycdid)
      sessionStorage.setItem('yhid', this.$route.query.yhid)
      sessionStorage.setItem('yhmc', this.$route.query.realname)
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
      sessionStorage.setItem('token', decodeURIComponent(this.$route.query.token))
      this.$store.commit("setYycdid", Number(this.$route.query.yycdid))
      this.$store.commit("setInfo", userInfo)
      this.$store.commit("setToken", decodeURIComponent(this.$route.query.token))
      this.$router.push({
        path: "/sw/gameList",
        query: {
          id: 2,
          name: '快速阅读'
        }
      })
    }
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.login {

  .main {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    img {
      animation-delay: 2s;
    }

    .text {
      color: #333;
      font-size: 32px;
      padding-top: 30px;
      animation-delay: 2s;
    }
  }
}
</style>



